const BASE = '$root'

export const PANE_LOADING = `${BASE}/pane/loading`;
export const CURRENT_MAIL_ITEM = `${BASE}/current/mailItem`;
export const VALID_DOMAIN = `${BASE}/validDomain`;

export const RECIPIENTS_WITH_STATUS_GET = `${BASE}/recipientsWithStatus/get`;
export const RECIPIENTS_WITH_STATUS_SET = `${BASE}/recipientsWithStatus/set`;
export const RECIPIENTS_WITH_STATUS_SELECT_CHANGE = `${BASE}/recipientsWithStatus/select/change`;

export const ORIGINAL_RECIPIENTS_GET = `${BASE}/originalRecipient/get`;
export const ORIGINAL_RECIPIENTS_SET = `${BASE}/originalRecipient/set`;

export const INDEXED_RECIPIENTS_GET = `${BASE}/indexedRecipient/get`;
export const INDEXED_RECIPIENTS_SET = `${BASE}/indexedRecipient/set`;

export const SEARCH_TARGET_GET = `${BASE}/searchTarget/get`;
export const SEARCH_TARGET_SET = `${BASE}/searchTarget/set`;